import { MouseEvent } from 'react'
import { PiGraph } from 'react-icons/pi'
import { Button, ButtonProps } from '~/@/components/ui/button'
import { ComprehensionEntityType } from '~/common/generated/apollo-operations'
import { useGlobalContext } from '~/common/hooks/useGlobalContext'
import { useTypedTranslation } from '~/common/hooks/useTypedTranslation'

interface OpenDependencyExplorerButtonProps {
  entityType: ComprehensionEntityType
  entityId: string | null | undefined
  className?: string
  variant?: ButtonProps['variant']
}

// Opens the Dependency Explorer for a given focal entity in a new tab, letting the user explore
// its dependency graph without leaving their current context.
export const OpenDependencyExplorerButton = ({
  entityType,
  entityId,
  className,
  variant = 'secondary',
}: OpenDependencyExplorerButtonProps) => {
  const { t } = useTypedTranslation()
  const { isInternal } = useGlobalContext()

  if (!isInternal || !entityId) {
    return null
  }

  const href = `/dependency-explorer?type=${encodeURIComponent(entityType)}&id=${encodeURIComponent(entityId)}`

  const handleClick = (e: MouseEvent) => {
    e.stopPropagation()
    window.open(href, '_blank', 'noopener,noreferrer')
  }

  return (
    <Button
      className={className}
      onClick={handleClick}
      size="xs"
      startIcon={<PiGraph className="size-3.5" />}
      variant={variant}
    >
      {t('dependency_explorer.open_in_explorer')}
    </Button>
  )
}
